/* global Audio */
/**
 * Servicio para reproducir sonidos de notificación
 */
class SoundService {
    constructor() {
        this.audioCache = new Map()
        this.lastPlayedTimestamps = new Map() // Para evitar reproducir el mismo sonido múltiples veces
        this.cooldownPeriod = 3000 // 3 segundos de cooldown entre reproducciones del mismo timer (permite repetir pero no saturar)
    }

    /**
     * Reproduce un sonido de notificación
     * @param {string} soundPath - Ruta del archivo de sonido
     * @param {number} volume - Volumen (0.0 a 1.0), por defecto 1.0 (máximo)
     * @param {string} timerId - ID del timer para evitar reproducciones múltiples
     */
    playNotificationSound(soundPath = '/sounds/timer-expired-alert.mp3', volume = 1.0, timerId = null) {
        try {
            if (timerId) {
                const lastPlayed = this.lastPlayedTimestamps.get(timerId)
                const now = Date.now()
                if (lastPlayed && (now - lastPlayed) < this.cooldownPeriod) {
                    return
                }
            }

            // eslint-disable-next-line no-undef
            const audio = new Audio(soundPath)
            audio.volume = Math.max(0, Math.min(1, volume))
            audio.addEventListener('error', () => {})

            // Registrar el timestamp síncronamente antes de play() para que
            // cualquier llamada simultánea al método ya encuentre el cooldown activo.
            if (timerId) {
                this.lastPlayedTimestamps.set(timerId, Date.now())
            }

            const cacheKey = timerId || soundPath
            this.audioCache.set(cacheKey, audio)

            const playPromise = audio.play()

            if (playPromise !== undefined) {
                playPromise
                    .then(() => {
                        audio.addEventListener('ended', () => {
                            this.audioCache.delete(cacheKey)
                            audio.src = ''
                        })
                    })
                    .catch(() => {
                        this.audioCache.delete(cacheKey)
                        if (timerId) {
                            this.lastPlayedTimestamps.delete(timerId)
                        }
                    })
            }
        } catch (_) {}
    }

    /**
     * Detiene todo el audio en curso y limpia el estado interno.
     */
    clearCache() {
        this.audioCache.forEach((audio) => {
            audio.pause()
            audio.src = ''
        })
        this.audioCache.clear()
        this.lastPlayedTimestamps.clear()
    }
}

// Exportar instancia singleton
export const soundService = new SoundService()
